import { DraftConfiguration, DraftState } from '@/types';
import { isDraftDesignConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';

export const setFilterDesignIdAction =
  ({ cid }: DraftConfiguration, designId: string) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftDesignConfiguration(configuration) && configuration.filter) {
      configuration.filter.designId = designId;
    }
  };
